import { useMutation } from 'react-query'
import { type TaskPersistence } from '../../../../types/persistence/task-persistence'
import { api } from '../../../api'

const createTask = async (data: TaskPersistence) => {
  const response = await api.post('/tasks', data)
  return response.data
}

export const useTaskCreateMutation = () => {
  return useMutation({
    mutationFn (data: TaskPersistence) {
      return createTask(data)
    },
  })
}
